module.exports = __webpack_public_path__ + "static/media/img13.f7884fca.jpg";